import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    container: {
        boxShadow: '1px 1px 1px 2px rgb(0, 0, 0, 0.1)',
        padding: '16px',
    },
    dividerPreco: {
        margin: theme.spacing(1, 0),
        borderBottom: '1px dashed ' + theme.palette.grey[100],
    },
    divider: {
        backgroundColor: theme.palette.primary.main,
    },
    cardAReceber: {
        padding: '4px 8px',
        borderRadius: 4,
        color: theme.palette.warning.contrastText,
        fontWeight: 'bold',
        backgroundColor: theme.palette.warning.main
    },
    cardAReceberPago: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.success.contrastText,
    },
}))